module.exports = __webpack_public_path__ + "static/media/puzzle0402.7a3be3e7.png";